"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const prefix = '/api/ac/v2/kyb/service/management/member/published';
const API = {
    listMember: `${prefix}/list`,
    inviteMember: `${prefix}/invite`,
    resendInvite: `${prefix}/resendInvite`,
    removeInvite: `${prefix}/removeInvite`,
    updateMemberRole: `${prefix}/update`,
    removeMember: `${prefix}/remove`,
};
class KYBServiceMember {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getListMember(serviceId) {
        const res = await this._httpClient.get(API.listMember, {
            params: { serviceId },
        });
        const data = {
            result: null,
            paging: {
                page: 0,
                limit: 100,
                total: 0,
            },
            entities: {},
        };
        const resBody = _.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        data.paging.total = resBody.result.length;
        return data;
    }
    async inviteMember(serviceId, { userEmail, serviceRole }) {
        const res = await this._httpClient.post(API.inviteMember, {
            serviceId,
            email: userEmail,
            role: serviceRole,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = _.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async resendInvite(serviceId, invitationId) {
        const res = await this._httpClient.post(API.resendInvite, {
            serviceId,
            invitationId,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = _.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async removeInvite(serviceId, invitationId) {
        await this._httpClient.delete(API.removeInvite, {
            data: {
                serviceId,
                invitationId,
            },
        });
        return {
            result: null,
            entities: {},
        };
    }
    async updateMemberRole(serviceId, { memberId, role }) {
        await this._httpClient.put(API.updateMemberRole, {
            serviceId,
            memberId,
            role,
        });
        return {
            result: null,
            entities: {},
        };
    }
    async removeMember(serviceId, { memberId, role }) {
        await this._httpClient.delete(API.removeMember, {
            data: { serviceId, memberId, role },
        });
        return {
            result: null,
            entities: {},
        };
    }
}
exports.default = KYBServiceMember;
